/*!
 * Esencias del Cielo · Guía «Encuentra tu aroma ideal» · v2 (oct 2026)
 * Módulo aislado: no depende de librerías ni modifica el tema.
 * Prefijo de clases/IDs: edcq-   ·   Datos olfativos: assets/aroma-quiz-catalog.json
 *
 * Regla de oro del motor (en este orden, sin excepciones):
 *   formato elegido → productos de ese formato → disponibles → exclusiones → coincidencia olfativa → orden
 * El formato es un FILTRO, nunca una puntuación. Si no hay suficientes coincidencias en ese formato,
 * se dice y se ofrece cambiar preferencias; jamás se rellena con otro formato.
 */
(function (global) {
  'use strict';

  /* =========================================================
   * 1. PREGUNTAS
   * ========================================================= */
  var QUESTIONS = [
    {
      key: 'sensation', type: 'multi', required: true,
      title: '¿Qué sensación quieres que tenga tu hogar?',
      hint: 'Puedes elegir una o varias.',
      options: [
        { v: 'fresco_limpio', t: 'Limpio y fresco' },
        { v: 'acogedor_dulce', t: 'Dulce y acogedor' },
        { v: 'natural_verde', t: 'Natural y verde' },
        { v: 'floral_delicado', t: 'Floral y delicado' },
        { v: 'calido_especiado', t: 'Cálido y especiado' },
        { v: 'frutal_luminoso', t: 'Frutal y luminoso' },
        { v: 'elegante_intenso', t: 'Elegante e intenso' }
      ]
    },
    {
      key: 'families', type: 'multi', required: true,
      title: '¿Qué aromas suelen gustarte más?',
      hint: 'Puedes elegir varios.',
      options: [
        { v: 'limpio', t: 'Ropa limpia y algodón' },
        { v: 'dulce', t: 'Vainilla, miel y dulces suaves' },
        { v: 'floral', t: 'Flores y notas delicadas' },
        { v: 'frutal', t: 'Cítricos y frutas' },
        { v: 'verde', t: 'Bosque, madera y notas verdes' },
        { v: 'especiado', t: 'Canela y especias' },
        { v: 'goloso', t: 'Chocolate, caramelo y aromas golosos' }
      ]
    },
    {
      key: 'avoid', type: 'multi', required: true, exclusive: 'ninguno',
      title: '¿Qué aromas prefieres evitar?',
      hint: 'Puedes marcar varios. No te recomendaremos nada que los lleve, aunque sea como matiz.',
      options: [
        { v: 'dulce', t: 'Dulces y golosos' },
        { v: 'floral', t: 'Florales' },
        { v: 'citrico_frutal', t: 'Cítricos y frutales' },
        { v: 'especiado', t: 'Especiados' },
        { v: 'verde_amaderado', t: 'Verdes y amaderados' },
        { v: 'intenso', t: 'Intensos' },
        { v: 'ninguno', t: 'Ninguno en particular' }
      ]
    },
    {
      key: 'intensity', type: 'single', required: true,
      title: '¿Qué intensidad prefieres?',
      options: [
        { v: 'suave', t: 'Suave y discreta' },
        { v: 'media', t: 'Equilibrada' },
        { v: 'intensa', t: 'Intensa y protagonista' },
        { v: 'nose', t: 'No lo tengo claro' }
      ]
    },
    {
      key: 'format', type: 'single', required: true, images: true, noAutoAdvance: ['descubrir'],
      title: '¿Qué formato quieres comprar?',
      hint: 'Solo te recomendaremos productos del formato que elijas.',
      options: [
        { v: 'vela', t: 'Velas aromáticas' },
        { v: 'wax_melt', t: 'Wax melts' },
        { v: 'textil', t: 'Ambientadores textiles y brumas' },
        { v: 'mikado', t: 'Mikados' },
        { v: 'coche', t: 'Ambientadores para coche' },
        { v: 'pack', t: 'Packs de productos' },
        { v: 'descubrir', t: 'Quiero descubrir qué formato me conviene' }
      ]
    },
    {
      key: 'space', type: 'single', required: true,
      title: '¿Dónde quieres disfrutar del aroma?',
      options: [
        { v: 'salon', t: 'Salón' },
        { v: 'dormitorio', t: 'Dormitorio' },
        { v: 'bano', t: 'Baño' },
        { v: 'varios', t: 'Distintas estancias' },
        { v: 'textiles', t: 'Textiles', s: 'Cojines, cortinas, ropa de cama' },
        { v: 'coche', t: 'Coche' },
        { v: 'regalo', t: 'Busco un regalo' }
      ]
    },
    {
      key: 'goal', type: 'single', required: true,
      title: '¿Qué buscas exactamente?',
      options: [
        { v: 'ideal', t: 'Quiero encontrar mi aroma ideal' },
        { v: 'renovar', t: 'Quiero renovar el aroma de mi hogar' },
        { v: 'regalo', t: 'Busco algo para regalar' },
        { v: 'probar', t: 'Quiero probar aromas diferentes' }
      ]
    }
  ];

  var FORMATS = ['vela', 'wax_melt', 'textil', 'mikado', 'coche', 'pack'];
  var FORMAT_INFO = {
    vela: { cat: 'Velas aromáticas', label: 'Vela de soja', plural: 'velas', explain: 'Perfuman mientras están encendidas y crean ambiente con su luz.' },
    wax_melt: { cat: 'Wax melts', label: 'Wax melt', plural: 'wax melts', explain: 'Porciones de cera que se funden en un quemador. Aroma intenso y puedes cambiar de fragancia cuando quieras.' },
    textil: { cat: 'Ambientadores textiles', label: 'Bruma textil', plural: 'ambientadores textiles', explain: 'Se pulverizan sobre cojines, cortinas, sofá o ropa de cama.' },
    mikado: { cat: 'Mikados', label: 'Difusor de varillas', plural: 'mikados', explain: 'Perfuman solos durante semanas, sin llama ni electricidad.' },
    coche: { cat: 'Ambientadores para coche', label: 'Ambientador de coche', plural: 'ambientadores de coche', explain: 'Para que el coche huela bien en cada trayecto durante semanas.' },
    pack: { cat: 'Packs', label: 'Pack', plural: 'packs', explain: 'Un mismo aroma en dos formatos, listos para disfrutar o regalar.' }
  };
  var AVOID_LABEL = { dulce: 'dulces y golosos', floral: 'florales', citrico_frutal: 'cítricos y frutales', especiado: 'especiados', verde_amaderado: 'verdes y amaderados', intenso: 'intensos' };
  var FAMILY_SHORT = { limpio: 'limpios', dulce: 'dulces y suaves', floral: 'florales', frutal: 'cítricos y frutales', verde: 'verdes y de bosque', especiado: 'especiados', goloso: 'golosos' };
  var SENSATION_PHRASE = {
    fresco_limpio: 'limpia y fresca', acogedor_dulce: 'dulce y acogedora', natural_verde: 'natural y verde',
    floral_delicado: 'floral y delicada', calido_especiado: 'cálida y especiada', frutal_luminoso: 'frutal y luminosa',
    elegante_intenso: 'elegante e intensa'
  };
  var SPACE_PHRASE = { salon: 'el salón', dormitorio: 'el dormitorio', bano: 'el baño', cocina: 'la cocina', recibidor: 'el recibidor', toda_casa: 'toda la casa' };

  /* =========================================================
   * 2. MOTOR DE RECOMENDACIÓN (puro, sin DOM: se prueba aparte)
   * ========================================================= */
  var Engine = {
    RELIABLE_MIN: 18,   // afinidad olfativa mínima para considerar que «encaja»
    MAX_RESULTS: 8,     // 3 visibles + «Ver más productos compatibles»
    VISIBLE: 3,

    avoidList: function (a) { return (a.avoid || []).filter(function (x) { return x !== 'ninguno'; }); },

    /** Formatos permitidos. Formato concreto = SOLO ese formato. */
    allowedFormats: function (a) {
      if (a.format && a.format !== 'descubrir') return [a.format];
      // «Quiero descubrir»: todos los formatos aromáticos compatibles con el lugar
      if (a.space === 'coche') return ['coche'];
      if (a.space === 'textiles') return ['textil', 'pack'];
      if (a.space === 'regalo') return FORMATS.slice();
      return ['vela', 'wax_melt', 'textil', 'mikado', 'pack']; // el ambientador de coche solo está documentado para el coche
    },

    /** Formato elegido y lugar incompatibles según las fichas → se avisa, no se cambia nada solo. */
    conflict: function (a) {
      var f = a.format, s = a.space;
      if (!f || f === 'descubrir') return null;
      if (s === 'coche' && f !== 'coche') return 'coche';
      if (f === 'coche' && s && s !== 'coche' && s !== 'regalo') return 'coche-fuera';
      if (s === 'textiles' && f !== 'textil' && f !== 'pack') return 'textiles';
      return null;
    },

    /** Paso 1: formato (y lugar, si es incompatible). Devuelve true si el producto entra. */
    passesFormat: function (item, a) {
      if (Engine.allowedFormats(a).indexOf(item.format) === -1) return false;
      if (a.space === 'textiles' && item.format === 'pack') return (item.packFormats || []).indexOf('textil') !== -1;
      return true;
    },

    /** Paso 3: exclusiones explícitas. Una exclusión nunca se compensa con puntos. */
    excludedBy: function (item, a) {
      var avoid = Engine.avoidList(a);
      if (!avoid.length) return null;
      for (var i = 0; i < avoid.length; i++) {
        if ((item.exclude || []).indexOf(avoid[i]) !== -1) return avoid[i];
      }
      // Ficha incompleta: no podemos garantizar que no lleve lo que quiere evitar
      if (item.info === 'basica') return 'sin-verificar';
      return null;
    },

    /** Paso 4: afinidad olfativa (las preferencias olfativas pesan más que las secundarias). */
    score: function (item, a) {
      var r = { item: item, score: 0, aroma: 0, famHits: [], sensHits: [], spaceHit: null, intensityHit: null };
      var fams = item.families || [];
      var fam = 0;
      (a.families || []).forEach(function (f) {
        var idx = fams.indexOf(f);
        if (idx === 0) { fam += 30; r.famHits.push(f); }
        else if (idx > 0) { fam += 18; r.famHits.push(f); }
      });
      fam = Math.min(fam, 54);
      var sens = 0;
      (a.sensation || []).forEach(function (s) {
        var idx = (item.sensations || []).indexOf(s);
        if (idx === 0) { sens += 20; r.sensHits.push(s); }
        else if (idx > 0) { sens += 12; r.sensHits.push(s); }
      });
      sens = Math.min(sens, 28);
      r.aroma = fam + sens;
      r.score = r.aroma;

      // Intensidad: solo si la ficha la documenta y la clienta tiene preferencia
      if (a.intensity && a.intensity !== 'nose' && item.intensity && item.intensity.length) {
        if (item.intensity.indexOf(a.intensity) !== -1) { r.score += 8; r.intensityHit = true; }
        else { r.score -= 10; r.intensityHit = false; }
      }
      // Estancia: solo las que nombra la ficha
      var sp = item.spaces || [];
      if (a.space && SPACE_PHRASE[a.space] && sp.indexOf(a.space) !== -1) { r.score += 6; r.spaceHit = a.space; }
      if (a.space === 'varios' && (sp.length >= 3 || sp.indexOf('toda_casa') !== -1)) { r.score += 4; }
      // Regalo: pequeño desempate, nunca cambia la compatibilidad
      if ((a.goal === 'regalo' || a.space === 'regalo') && item.gift) r.score += 3;
      // Ficha incompleta: nunca por delante de una con notas completas a igualdad de afinidad
      if (item.info === 'basica') r.score -= 6;
      return r;
    },

    /**
     * Ranking completo. `avail` = { itemId: true | false } (sin clave = no se pudo comprobar).
     * Devuelve todo lo necesario para pintar y para las pruebas.
     */
    rank: function (catalog, a, avail) {
      avail = avail || {};
      var out = {
        conflict: Engine.conflict(a), formats: Engine.allowedFormats(a),
        poolCount: 0, availableCount: 0, excludedCount: 0, excludedReasons: {},
        picks: [], soldOut: [], best: null, complements: []
      };
      if (out.conflict) return out;
      var scored = [];
      catalog.forEach(function (item) {
        // 1. Formato (filtro excluyente)
        if (!Engine.passesFormat(item, a)) return;
        // Packs sin aromas fijos (a elegir / sorpresa): solo como complemento, nunca principal
        if (item.info === 'sin_aromas_fijos') { out.complements.push(item); return; }
        out.poolCount++;
        // 2. Disponibilidad
        var isSoldOut = avail[item.id] === false;
        if (!isSoldOut) out.availableCount++;
        // 3. Exclusiones
        var ex = Engine.excludedBy(item, a);
        if (ex) { out.excludedCount++; out.excludedReasons[ex] = (out.excludedReasons[ex] || 0) + 1; return; }
        // 4. Afinidad olfativa
        var r = Engine.score(item, a);
        if (r.aroma < Engine.RELIABLE_MIN) return;
        r.availability = isSoldOut ? 'agotado' : (avail[item.id] === true ? 'disponible' : 'sin-confirmar');
        scored.push(r);
      });
      // 5. Orden por afinidad (nunca por precio, margen ni stock)
      scored.sort(function (x, y) { return (y.score - x.score) || (y.aroma - x.aroma) || (x.item.name < y.item.name ? -1 : 1); });

      var seenAroma = {};
      var mixed = out.formats.length > 1;
      scored.forEach(function (r) {
        var it = r.item;
        if (r.availability === 'agotado') { if (out.soldOut.length < 2) out.soldOut.push(r); return; }
        if (out.picks.length >= Engine.MAX_RESULTS) return;
        // En modo «descubrir», variedad de aromas: el mismo aroma solo en su formato mejor puntuado
        if (mixed && seenAroma[it.aroma]) return;
        seenAroma[it.aroma] = true;
        out.picks.push(r);
      });
      // Un agotado que ya aparece disponible en el mismo formato con otro producto no se menciona
      out.soldOut = out.soldOut.filter(function (r) { return !out.picks.some(function (p) { return p.item.aroma === r.item.aroma && p.item.format === r.item.format; }); });
      // 6. «Tu mejor coincidencia» solo cuando el resultado lo justifica
      var p = out.picks;
      if (p.length && p[0].item.info === 'completa' && p[0].aroma >= 30 && (p.length === 1 || p[0].score - p[1].score >= 8)) out.best = p[0];
      return out;
    },

    /** Texto «por qué encaja contigo», solo con datos reales de la ficha. */
    explain: function (r, a) {
      var it = r.item, parts = [];
      if (r.famHits.length) parts.push('Te gustan los aromas ' + joinEs(r.famHits.map(function (f) { return FAMILY_SHORT[f]; })) + '.');
      else if (r.sensHits.length) parts.push('Buscas una casa ' + SENSATION_PHRASE[r.sensHits[0]] + '.');
      if (it.notes) parts.push((it.info === 'basica' ? 'Aroma: ' : 'Huele a ') + it.notes + '.');
      var avoid = Engine.avoidList(a);
      if (avoid.length) parts.push('No lleva notas ' + joinEs(avoid.map(function (x) { return AVOID_LABEL[x]; })) + ' según su ficha.');
      if (r.spaceHit) parts.push('Su ficha lo recomienda para ' + SPACE_PHRASE[r.spaceHit] + '.');
      if (r.intensityHit === true) parts.push(a.intensity === 'intensa' ? 'Es un aroma con presencia, como te gusta.' : a.intensity === 'suave' ? 'Su ficha lo describe como un aroma suave.' : 'Tiene una intensidad equilibrada.');
      return parts.join(' ');
    }
  };

  function joinEs(arr) {
    if (arr.length <= 1) return arr.join('');
    return arr.slice(0, -1).join(', ') + ' y ' + arr[arr.length - 1];
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { Engine: Engine, QUESTIONS: QUESTIONS, FORMAT_INFO: FORMAT_INFO };
  }
  if (typeof document === 'undefined') return;

  /* =========================================================
   * 3. UTILIDADES (almacenamiento seguro, analítica con consentimiento)
   * ========================================================= */
  var KEY = { state: 'edcq_state_v2', dismissed: 'edcq_dismissed_v1', done: 'edcq_done_v2', recs: 'edcq_recs_v2', session: 'edcq_session_v1', burner: 'edcq_burner_v1' };
  var DAY = 864e5;

  function lsGet(k, ttlDays) {
    try {
      var raw = localStorage.getItem(k); if (!raw) return null;
      var o = JSON.parse(raw);
      if (ttlDays && o && o.ts && Date.now() - o.ts > ttlDays * DAY) { localStorage.removeItem(k); return null; }
      return o;
    } catch (e) { return null; }
  }
  function lsSet(k, v) { try { v.ts = Date.now(); localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function consent(kind) {
    try {
      var cp = global.Shopify && global.Shopify.customerPrivacy;
      if (!cp) return false;
      if (kind === 'marketing') return typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
      return typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed();
    } catch (e) { return false; }
  }
  var META_EVENTS = { edc_quiz_complete: 'GuiaAromas_Completada', edc_quiz_product_click: 'GuiaAromas_ClicProducto', edc_quiz_add_to_cart: 'GuiaAromas_AnadidoCarrito' };
  function track(name, data) {
    data = data || {};
    try {
      if (consent('analytics') && global.Shopify && global.Shopify.analytics && typeof global.Shopify.analytics.publish === 'function') {
        global.Shopify.analytics.publish(name, data);
      }
      if (META_EVENTS[name] && consent('marketing') && typeof global.fbq === 'function') {
        global.fbq('trackCustom', META_EVENTS[name], data);
      }
    } catch (e) {}
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function money(cents) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); }
  function imgSized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  var reduceMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* =========================================================
   * 4. DATOS EN DIRECTO (precio, foto, stock y enlace reales)
   * ========================================================= */
  var root = document.getElementById('edcq-root');
  if (!root) return;
  var cfg = {
    catalogUrl: root.getAttribute('data-catalog'),
    template: root.getAttribute('data-template') || '',
    designMode: root.getAttribute('data-design-mode') === 'true',
    base: (root.getAttribute('data-root') || '/').replace(/\/?$/, '/'),
    formatImages: {}
  };
  try { cfg.formatImages = JSON.parse((document.getElementById('edcq-format-images') || {}).textContent || '{}'); } catch (e) {}

  var AUTO_TEMPLATES = ['index', 'collection', 'list-collections', 'page', 'blog', 'article', 'search'];
  var NO_TAB_TEMPLATES = ['cart'];
  var catalogPromise = null, storePromise = null, productCache = {};

  function loadCatalog() {
    if (!catalogPromise) {
      catalogPromise = fetch(cfg.catalogUrl, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('catalog'); return r.json(); });
    }
    return catalogPromise;
  }
  /** Una sola petición con todo el catálogo publicado (stock y precio en directo). */
  function loadStore() {
    if (!storePromise) {
      storePromise = fetch(cfg.base + 'products.json?limit=250', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('store'); return r.json(); })
        .then(function (j) {
          var map = {};
          (j.products || []).forEach(function (p) {
            map[p.handle] = {
              id: String(p.id), handle: p.handle, title: p.title, image: (p.images && p.images[0] && p.images[0].src) || '',
              variants: (p.variants || []).map(function (v) {
                return { id: String(v.id), title: v.title, available: !!v.available, price: Math.round(parseFloat(v.price) * 100), image: v.featured_image && v.featured_image.src };
              })
            };
          });
          return map;
        })
        .catch(function () { return null; }); // si falla, se consulta producto a producto
    }
    return storePromise;
  }
  function loadProductJs(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(cfg.base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          return { id: String(p.id), handle: p.handle, title: p.title, image: p.featured_image || '',
            variants: (p.variants || []).map(function (v) { return { id: String(v.id), title: v.title, available: !!v.available, price: v.price, image: v.featured_image && v.featured_image.src }; }) };
        })
        .catch(function () { return undefined; }); // undefined = no se pudo comprobar
    }
    return productCache[handle];
  }
  function getProduct(handle, store) {
    if (store) return Promise.resolve(store[handle] || null); // null = no publicado en la tienda online
    return loadProductJs(handle);
  }
  /** Une la ficha olfativa con el producto real. */
  function resolve(item, store) {
    return getProduct(item.handle, store).then(function (p) {
      if (p === undefined) return { unknown: true };
      if (!p) return { missing: true };
      var v = null;
      if (item.variant) {
        var target = norm(item.variant);
        v = p.variants.filter(function (x) { return norm(x.title) === target; })[0] || null;
        if (!v) return { missing: true };
      } else {
        v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      }
      var anyAvail = p.variants.some(function (x) { return x.available; });
      return {
        available: item.variant ? !!(v && v.available) : anyAvail,
        price: v ? v.price : null,
        image: (v && v.image) || p.image || '',
        productId: p.id, variantId: v ? v.id : null,
        title: (p.title || item.name) + (item.variant && v ? ' · ' + v.title.replace(/\(\s+/g, '(').replace(/\s+\)/g, ')') : ''),
        url: cfg.base + 'products/' + p.handle + (item.variant && v ? '?variant=' + v.id : '')
      };
    });
  }

  /* =========================================================
   * 5. INTERFAZ
   * ========================================================= */
  var state = { step: 0, answers: {} }; // 0 = invitación, 1..7 preguntas, 8 = resultados
  var resumeStep = 0;
  var saved = lsGet(KEY.state, 30);
  if (saved && saved.answers) { state.answers = saved.answers; resumeStep = saved.step || 0; }
  var dialog, body, progressBar, progressText, lastFocus, opened = false;
  var RESULTS = QUESTIONS.length + 1;

  function persist() {
    if (state.step > 0) resumeStep = state.step;
    lsSet(KEY.state, { answers: state.answers, step: resumeStep });
  }

  function build() {
    if (dialog) return;
    dialog = el('dialog', { class: 'edcq-dialog', 'aria-labelledby': 'edcq-title', 'aria-describedby': 'edcq-desc' });
    var closeBtn = el('button', { class: 'edcq-close', type: 'button', 'aria-label': 'Cerrar la guía de aromas', onclick: function () { close('button'); } });
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    progressBar = el('div', { class: 'edcq-progress__bar' });
    progressText = el('p', { class: 'edcq-progress__text', 'aria-live': 'polite' });
    var progress = el('div', { class: 'edcq-progress', hidden: '' }, [
      el('div', { class: 'edcq-progress__track', role: 'presentation' }, [progressBar]), progressText
    ]);
    body = el('div', { class: 'edcq-body' });
    dialog.appendChild(el('div', { class: 'edcq-panel' }, [closeBtn, progress, body]));
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close('escape'); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close('backdrop'); });
    document.body.appendChild(dialog);
  }

  function open(source) {
    build();
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    ssSet(KEY.session, '1');
    state.step = 0;
    render();
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    focusStep();
    document.documentElement.classList.add('edcq-lock');
    if (source && source.indexOf('auto') === 0) track('edc_quiz_popup_impression', { source: source, template: cfg.template });
    track('edc_quiz_popup_open', { source: source || 'unknown', template: cfg.template });
    loadCatalog().catch(function () {});
  }
  function close(how) {
    if (!opened) return;
    opened = false;
    if (state.step < RESULTS) lsSet(KEY.dismissed, { how: how });
    track('edc_quiz_close', { step: state.step, how: how });
    persist();
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    document.documentElement.classList.remove('edcq-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function setProgress() {
    var p = dialog.querySelector('.edcq-progress');
    if (state.step >= 1 && state.step <= QUESTIONS.length) {
      p.hidden = false;
      progressBar.style.width = Math.round((state.step / QUESTIONS.length) * 100) + '%';
      progressText.textContent = 'Pregunta ' + state.step + ' de ' + QUESTIONS.length;
    } else { p.hidden = true; }
  }

  function render() {
    setProgress();
    body.innerHTML = '';
    body.scrollTop = 0;
    if (state.step === 0) renderIntro();
    else if (state.step <= QUESTIONS.length) renderQuestion(QUESTIONS[state.step - 1]);
    else renderResults();
    focusStep();
  }
  function focusStep() {
    var f = body.querySelector('[data-autofocus]') || body.querySelector('h2');
    if (f) { if (f.tagName === 'H2') f.setAttribute('tabindex', '-1'); try { f.focus({ preventScroll: true }); } catch (e) {} }
  }
  function go(step) { state.step = step; persist(); render(); }
  function goKey(key) { for (var i = 0; i < QUESTIONS.length; i++) if (QUESTIONS[i].key === key) return go(i + 1); }

  function renderIntro() {
    var hasProgress = Object.keys(state.answers).length > 0 && resumeStep > 0;
    var finished = resumeStep > QUESTIONS.length;
    body.appendChild(el('div', { class: 'edcq-intro' }, [
      el('p', { class: 'edcq-eyebrow', text: 'Guía de aromas · Esencias del Cielo' }),
      el('h2', { id: 'edcq-title', class: 'edcq-h', text: '¿Cuál es el aroma que encaja contigo?' }),
      el('p', { id: 'edcq-desc', class: 'edcq-lead', text: 'Cuéntanos qué aromas te gustan, qué sensación buscas para tu hogar y cómo quieres disfrutar de ellos. Te ayudaremos a descubrir los productos de Esencias del Cielo que mejor encajan contigo, incluso si no puedes olerlos desde casa.' }),
      el('div', { class: 'edcq-actions edcq-actions--stack' }, [
        el('button', { class: 'edcq-btn edcq-btn--primary', type: 'button', 'data-autofocus': '', text: !hasProgress ? 'ENCONTRAR MI AROMA' : finished ? 'VER MIS AROMAS' : 'CONTINUAR DONDE LO DEJÉ', onclick: function () {
          track('edc_quiz_start', { resume: !!hasProgress });
          go(hasProgress ? Math.min(resumeStep, RESULTS) : 1);
        } }),
        hasProgress ? el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Empezar de nuevo', onclick: function () { state.answers = {}; resumeStep = 0; track('edc_quiz_start', { resume: false }); go(1); } }) : null
      ]),
      el('p', { class: 'edcq-note', text: 'Un pequeño test para encontrar tus próximos aromas favoritos.' })
    ]));
  }

  function isAnswered(q) {
    var v = state.answers[q.key];
    return q.type === 'multi' ? Array.isArray(v) && v.length > 0 : !!v;
  }

  function formatExplainer() {
    return el('div', { class: 'edcq-explainer', 'aria-live': 'polite' }, [
      el('p', { class: 'edcq-explainer__title', text: 'Así se diferencian nuestros formatos' }),
      el('ul', {}, FORMATS.map(function (f) {
        return el('li', {}, [el('strong', { text: FORMAT_INFO[f].cat + ': ' }), FORMAT_INFO[f].explain]);
      })),
      el('p', { class: 'edcq-explainer__note', text: 'Te enseñaremos productos de varios formatos que encajen con tus aromas, cada uno con su formato bien indicado.' })
    ]);
  }

  function renderQuestion(q) {
    var idx = QUESTIONS.indexOf(q);
    var isLast = idx === QUESTIONS.length - 1;
    var err = el('p', { class: 'edcq-error', role: 'status', 'aria-live': 'polite' });
    var groupId = 'edcq-q-' + q.key;
    var list = el('div', {
      class: 'edcq-options' + (q.images ? ' edcq-options--img' : ''),
      role: q.type === 'single' ? 'radiogroup' : 'group', 'aria-labelledby': groupId
    });
    q.options.forEach(function (o, i) {
      var selected = q.type === 'multi' ? (state.answers[q.key] || []).indexOf(o.v) !== -1 : state.answers[q.key] === o.v;
      var img = q.images && cfg.formatImages[o.v] ? el('img', { class: 'edcq-opt__img', src: cfg.formatImages[o.v], alt: '', loading: 'lazy', width: '120', height: '120' }) : null;
      var btn = el('button', {
        type: 'button', class: 'edcq-opt' + (selected ? ' is-selected' : ''),
        role: q.type === 'single' ? 'radio' : 'checkbox', 'aria-checked': selected ? 'true' : 'false',
        'data-v': o.v,
        'data-autofocus': (selected || (!isAnswered(q) && i === 0)) ? '' : null,
        onclick: function () { choose(q, o.v); }
      }, [
        img,
        el('span', { class: 'edcq-opt__check', 'aria-hidden': 'true' }),
        el('span', { class: 'edcq-opt__text' }, [
          el('span', { class: 'edcq-opt__title', text: o.t }),
          o.s ? el('span', { class: 'edcq-opt__sub', text: o.s }) : null
        ])
      ]);
      list.appendChild(btn);
    });
    var explainerSlot = el('div', { class: 'edcq-explainer-slot' });
    if (q.key === 'format' && state.answers.format === 'descubrir') explainerSlot.appendChild(formatExplainer());

    body.appendChild(el('div', { class: 'edcq-question' }, [
      el('h2', { id: groupId, class: 'edcq-h edcq-h--q', text: q.title }),
      q.hint ? el('p', { class: 'edcq-hint', text: q.hint }) : null,
      list, explainerSlot, err,
      el('div', { class: 'edcq-actions' }, [
        el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Atrás', onclick: function () { go(state.step - 1); } }),
        el('button', { class: 'edcq-btn edcq-btn--primary', type: 'button', 'data-next': '', text: isLast ? 'Descubrir mis aromas' : 'Continuar', onclick: function () {
          if (!isAnswered(q)) { err.textContent = q.type === 'multi' ? 'Marca al menos una opción para seguir.' : 'Elige una opción para seguir.'; return; }
          track('edc_quiz_answer', { question: q.key, value: [].concat(state.answers[q.key]).join(',') });
          if (isLast) { track('edc_quiz_complete', { format: state.answers.format || '' }); lsSet(KEY.done, {}); }
          go(state.step + 1);
        } })
      ])
    ]));
  }

  function choose(q, v) {
    var btns = body.querySelectorAll('.edcq-opt');
    var er = body.querySelector('.edcq-error'); if (er) er.textContent = '';
    if (q.type === 'multi') {
      var cur = (state.answers[q.key] || []).slice();
      var i = cur.indexOf(v);
      if (i !== -1) cur.splice(i, 1);
      else if (q.exclusive && v === q.exclusive) cur = [v];
      else { cur = cur.filter(function (x) { return x !== q.exclusive; }); cur.push(v); }
      state.answers[q.key] = cur;
      persist();
      q.options.forEach(function (o, k) {
        var on = cur.indexOf(o.v) !== -1;
        btns[k].classList.toggle('is-selected', on);
        btns[k].setAttribute('aria-checked', on ? 'true' : 'false');
      });
      return;
    }
    state.answers[q.key] = v;
    persist();
    q.options.forEach(function (o, k) {
      btns[k].classList.toggle('is-selected', o.v === v);
      btns[k].setAttribute('aria-checked', o.v === v ? 'true' : 'false');
    });
    if (q.key === 'format') {
      var slot = body.querySelector('.edcq-explainer-slot');
      slot.innerHTML = '';
      if (v === 'descubrir') slot.appendChild(formatExplainer());
    }
    var isLast = QUESTIONS.indexOf(q) === QUESTIONS.length - 1;
    if (isLast || (q.noAutoAdvance || []).indexOf(v) !== -1) return;
    // Avance automático en preguntas de una respuesta (siempre se puede volver con «Atrás»)
    setTimeout(function () {
      if (opened && QUESTIONS[state.step - 1] === q && state.answers[q.key] === v) {
        track('edc_quiz_answer', { question: q.key, value: v });
        go(state.step + 1);
      }
    }, reduceMotion ? 120 : 380);
  }

  /* ---------- Resultados ---------- */
  function renderResults() {
    var a = state.answers;
    body.appendChild(el('div', { class: 'edcq-loading', role: 'status' }, [
      el('span', { class: 'edcq-spinner', 'aria-hidden': 'true' }),
      el('span', { text: 'Buscando tus aromas…' })
    ]));
    var runId = Date.now(); renderResults.runId = runId;

    Promise.all([loadCatalog(), loadStore()]).then(function (res) {
      var data = res[0], store = res[1];
      var catalog = data.items || [];
      // Se consulta el stock real de todo el formato elegido (no solo de los primeros)
      var toCheck = catalog.filter(function (it) { return Engine.passesFormat(it, a); });
      var extra = (data.burners || []).map(function (b) { return { id: 'burner:' + b.handle, handle: b.handle }; });
      if (data.giftCardHandle) extra.push({ id: 'giftcard', handle: data.giftCardHandle });
      var all = toCheck.concat(extra);
      return Promise.all(all.map(function (it) { return resolve(it, store); })).then(function (live) {
        var avail = {}, liveById = {};
        all.forEach(function (it, i) {
          liveById[it.id] = live[i];
          if (live[i].missing) avail[it.id] = false;          // no está publicado: no se puede comprar
          else if (!live[i].unknown) avail[it.id] = !!live[i].available;
        });
        return { result: Engine.rank(catalog, a, avail), live: liveById, data: data, stockChecked: !!store || live.some(function (l) { return !l.unknown; }) };
      });
    }).then(function (o) {
      if (state.step !== RESULTS || renderResults.runId !== runId) return;
      body.innerHTML = '';
      showResults(o);
    }).catch(function () {
      body.innerHTML = '';
      body.appendChild(el('div', { class: 'edcq-empty' }, [
        el('h2', { class: 'edcq-h', text: 'No hemos podido cargar los aromas' }),
        el('p', { class: 'edcq-lead', text: 'Comprueba tu conexión y vuelve a intentarlo. Tus respuestas están guardadas.' }),
        el('div', { class: 'edcq-actions' }, [el('button', { class: 'edcq-btn edcq-btn--primary', type: 'button', text: 'Reintentar', onclick: function () { catalogPromise = null; storePromise = null; render(); } })])
      ]));
    });
  }

  function catLabel(it) {
    var f = FORMAT_INFO[it.format];
    if (it.format === 'pack') return 'Packs · ' + (it.packFormats || []).map(function (x) { return FORMAT_INFO[x].label.toLowerCase(); }).join(' + ');
    return f.cat + ' · ' + f.label;
  }

  function productCard(r, live, isBest, position) {
    var it = r.item;
    var click = function () {
      track('edc_quiz_product_click', { product: it.handle, variant: it.variant || '', format: it.format, position: position, best: !!isBest });
    };
    var cta = el('a', { class: 'edcq-btn edcq-btn--primary edcq-card__cta', href: live.url, text: 'Descubrir este producto', onclick: click });
    var media = el('a', { class: 'edcq-card__media', href: live.url, tabindex: '-1', 'aria-hidden': 'true', onclick: click }, [
      live.image ? el('img', { src: imgSized(live.image, 480), alt: '', loading: 'lazy', width: '480', height: '480' }) : null
    ]);
    return el('article', { class: 'edcq-card' + (isBest ? ' edcq-card--best' : ''), 'data-format': it.format, 'data-id': it.id }, [
      isBest ? el('p', { class: 'edcq-badge', text: 'Tu mejor coincidencia' }) : null,
      media,
      el('div', { class: 'edcq-card__body' }, [
        el('p', { class: 'edcq-card__format', text: catLabel(it) }),
        el('h3', { class: 'edcq-card__title', text: live.title || it.name }),
        live.price != null ? el('p', { class: 'edcq-card__price', text: money(live.price) }) : null,
        it.descr ? el('p', { class: 'edcq-card__descr', text: it.descr }) : null,
        el('p', { class: 'edcq-card__why' }, [el('strong', { text: 'Por qué encaja contigo: ' }), Engine.explain(r, state.answers)]),
        it.info === 'basica' ? el('p', { class: 'edcq-card__tip', text: 'Su ficha aún no detalla las notas olfativas: te lo proponemos por el nombre del aroma.' }) : null,
        r.availability === 'sin-confirmar' ? el('p', { class: 'edcq-card__tip', text: 'No hemos podido confirmar el stock ahora mismo: lo verás en la ficha.' }) : null,
        cta
      ])
    ]);
  }

  function adjustButtons(a) {
    return el('div', { class: 'edcq-actions edcq-actions--wrap edcq-adjust' }, [
      Engine.avoidList(a).length ? el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Cambiar aromas a evitar', onclick: function () { goKey('avoid'); } }) : null,
      el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Cambiar los aromas que me gustan', onclick: function () { goKey('families'); } }),
      el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Elegir otro formato', onclick: function () { goKey('format'); } })
    ]);
  }

  function introText(a, n) {
    var fi = a.format && a.format !== 'descubrir' ? FORMAT_INFO[a.format] : null;
    var lead = a.goal === 'regalo' || a.space === 'regalo' ? 'Para regalar, ' : a.goal === 'renovar' ? 'Para renovar el aroma de tu casa, ' : a.goal === 'probar' ? 'Para probar algo diferente, ' : '';
    var what = fi ? (n === 1 ? 'este producto de ' + fi.plural : 'estos ' + fi.plural) : (n === 1 ? 'esta propuesta' : 'estas propuestas de distintos formatos');
    return (lead ? lead + what : what.charAt(0).toUpperCase() + what.slice(1)) + (n === 1 ? ' encaja' : ' encajan') + ' con lo que nos has contado, según las notas reales de cada fragancia.';
  }

  function showResults(o) {
    var res = o.result, live = o.live, data = o.data, a = state.answers;
    var wrap = el('div', { class: 'edcq-results' });
    var fi = a.format && a.format !== 'descubrir' ? FORMAT_INFO[a.format] : null;
    var picks = res.picks.filter(function (r) { return live[r.item.id] && !live[r.item.id].missing; });

    if (res.conflict) {
      var msg = res.conflict === 'coche'
        ? 'Has elegido ' + FORMAT_INFO[a.format].plural + ', pero quieres el aroma para el coche, y estos productos no están pensados para eso. Puedes elegir los ambientadores para coche o cambiar el lugar.'
        : res.conflict === 'textiles'
        ? 'Has elegido ' + FORMAT_INFO[a.format].plural + ', pero quieres perfumar textiles. Para cojines, cortinas o ropa de cama están los ambientadores textiles. Puedes cambiar el formato o el lugar.'
        : 'Los ambientadores para coche están pensados solo para el coche. Si buscas aroma para tu casa, elige otro formato o cambia el lugar.';
      wrap.appendChild(el('h2', { class: 'edcq-h', text: 'Antes de seguir, una cosa' }));
      wrap.appendChild(el('p', { class: 'edcq-lead', text: msg }));
      wrap.appendChild(el('div', { class: 'edcq-actions edcq-actions--wrap' }, [
        el('button', { class: 'edcq-btn edcq-btn--primary', type: 'button', text: 'Cambiar el formato', onclick: function () { goKey('format'); } }),
        el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Cambiar el lugar', onclick: function () { goKey('space'); } })
      ]));
      track('edc_quiz_no_results', { reason: 'conflict-' + res.conflict, format: a.format });
      body.appendChild(wrap); return;
    }

    if (!picks.length) {
      wrap.appendChild(el('h2', { class: 'edcq-h', text: 'No hemos encontrado una selección suficientemente ajustada' }));
      var why = fi ? 'Entre nuestros ' + fi.plural + ' disponibles no hay ninguno que encaje de verdad con tus respuestas' : 'Ninguna de nuestras fragancias disponibles encaja de verdad con tus respuestas';
      if (res.excludedCount) why += ' y respete los aromas que prefieres evitar';
      wrap.appendChild(el('p', { class: 'edcq-lead', text: why + '. Preferimos decírtelo antes que recomendarte algo que no te va.' }));
      wrap.appendChild(el('p', { class: 'edcq-hint', text: 'Puedes ajustar alguna respuesta y lo recalculamos al momento.' }));
      wrap.appendChild(adjustButtons(a));
      track('edc_quiz_no_results', { reason: 'no-match', format: a.format || '', excluded: res.excludedCount });
    } else {
      wrap.appendChild(el('h2', { class: 'edcq-h', text: 'Estos aromas encajan contigo' }));
      wrap.appendChild(el('p', { class: 'edcq-lead', text: introText(a, picks.length) }));
      if (fi && picks.length < 3) {
        wrap.appendChild(el('p', { class: 'edcq-hint edcq-few', text: 'En ' + fi.plural + ' solo ' + (picks.length === 1 ? 'hay una opción que encaja' : 'hay dos opciones que encajan') + ' de verdad. Preferimos enseñarte pocas y acertadas; si quieres más opciones, ajusta alguna respuesta.' }));
      }
      var grid = el('div', { class: 'edcq-grid' });
      picks.forEach(function (r, i) {
        var card = productCard(r, live[r.item.id], res.best && res.best.item.id === r.item.id, i + 1);
        if (i >= Engine.VISIBLE) card.classList.add('edcq-card--more');
        grid.appendChild(card);
      });
      wrap.appendChild(grid);
      if (picks.length > Engine.VISIBLE) {
        var more = el('button', { class: 'edcq-btn edcq-btn--ghost edcq-more', type: 'button', 'aria-expanded': 'false', text: 'Ver más productos compatibles', onclick: function () {
          grid.classList.add('is-expanded'); more.setAttribute('aria-expanded', 'true'); more.hidden = true;
          var f = grid.querySelector('.edcq-card--more .edcq-card__cta'); if (f) f.focus();
          track('edc_quiz_show_more', { format: a.format || '' });
        } });
        wrap.appendChild(more);
      }
      if (fi && picks.length < 3) wrap.appendChild(adjustButtons(a));
      lsSet(KEY.recs, {
        products: picks.map(function (r) { return live[r.item.id].productId; }),
        variants: picks.filter(function (r) { return r.item.variant; }).map(function (r) { return live[r.item.id].variantId; })
      });
      track('edc_quiz_results', { format: a.format || '', count: picks.length, products: picks.map(function (r) { return r.item.handle + (r.item.variant ? ':' + r.item.variant : ''); }).join(',') });
    }

    // Producto que encajaría pero está agotado: se avisa sin botón de compra
    res.soldOut.forEach(function (r) {
      var lv = live[r.item.id]; if (!lv || lv.missing) return;
      wrap.appendChild(el('p', { class: 'edcq-soldout' }, ['También encajaría contigo ' + (lv.title || r.item.name) + ', pero ahora mismo está agotado.']));
    });

    // Complementos: bloque secundario, separado y solo si tiene sentido
    if (picks.length) {
      var hasWax = picks.some(function (r) { return r.item.format === 'wax_melt'; });
      if (hasWax) wrap.appendChild(burnerBlock(data, live, o.result));
      if (a.format === 'pack' || (a.goal === 'probar' && (a.format === 'wax_melt' || a.format === 'descubrir'))) {
        var c = res.complements.filter(function (it) { return live[it.id] && live[it.id].available; });
        // Aromas no fijos: solo si la clienta no ha excluido nada (no podemos garantizar qué llevan)
        if (Engine.avoidList(a).length) c = c.filter(function (it) { return it.id === 'pack-crea-tu-momento'; });
        if (c.length) wrap.appendChild(complementList('Otras ideas, por si te apetece', c.slice(0, 2), live, 'pack'));
      }
    }
    if ((a.goal === 'regalo' || a.space === 'regalo') && live.giftcard && live.giftcard.available) {
      wrap.appendChild(el('aside', { class: 'edcq-aside' }, [
        el('div', {}, [
          el('p', { class: 'edcq-aside__title', text: '¿No sabes qué aroma le gustará?' }),
          el('p', { class: 'edcq-aside__text', text: 'Con la Tarjeta Regalo elige la persona que lo recibe.' }),
          el('a', { href: live.giftcard.url, text: 'Ver la Tarjeta Regalo', onclick: function () { track('edc_quiz_product_click', { product: 'tarjeta-regalo', position: 'complemento' }); } })
        ])
      ]));
    }

    wrap.appendChild(el('div', { class: 'edcq-actions edcq-actions--wrap' }, [
      el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Cambiar mis respuestas', onclick: function () { go(1); } }),
      el('button', { class: 'edcq-btn edcq-btn--ghost', type: 'button', text: 'Volver a hacer el test', onclick: function () { state.answers = {}; resumeStep = 0; lsDel(KEY.recs); go(1); } })
    ]));
    body.appendChild(wrap);
    var h = wrap.querySelector('h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }

  function complementList(title, items, live, kind) {
    return el('aside', { class: 'edcq-aside edcq-aside--list', 'data-kind': kind }, [
      el('p', { class: 'edcq-aside__title', text: title }),
      el('div', { class: 'edcq-mini-grid' }, items.map(function (it) {
        var lv = live[it.id];
        return el('a', { class: 'edcq-mini', href: lv.url, onclick: function () { track('edc_quiz_product_click', { product: it.handle, position: 'complemento-' + kind }); } }, [
          lv.image ? el('img', { src: imgSized(lv.image, 200), alt: '', loading: 'lazy', width: '72', height: '72' }) : null,
          el('span', { class: 'edcq-mini__text' }, [
            el('span', { class: 'edcq-mini__kind', text: kind === 'burner' ? 'Accesorio · no es un aroma' : 'Pack' }),
            el('span', { class: 'edcq-mini__name', text: lv.title || it.name }),
            lv.price != null ? el('span', { class: 'edcq-mini__price', text: money(lv.price) }) : null,
            it.note ? el('span', { class: 'edcq-mini__note', text: it.note }) : null
          ])
        ]);
      }))
    ]);
  }

  function burnerBlock(data, live) {
    var box = el('aside', { class: 'edcq-aside edcq-aside--burner' });
    var answer = (lsGet(KEY.burner, 180) || {}).v;
    function paint() {
      box.innerHTML = '';
      box.appendChild(el('p', { class: 'edcq-aside__title', text: 'Los wax melts se funden en un quemador. ¿Ya tienes uno?' }));
      if (!answer) {
        box.appendChild(el('div', { class: 'edcq-actions edcq-actions--wrap' }, [
          el('button', { class: 'edcq-btn edcq-btn--ghost edcq-btn--sm', type: 'button', text: 'Sí, ya tengo', onclick: function () { answer = 'si'; lsSet(KEY.burner, { v: 'si' }); track('edc_quiz_burner', { has: 'si' }); paint(); } }),
          el('button', { class: 'edcq-btn edcq-btn--ghost edcq-btn--sm', type: 'button', text: 'No, todavía no', onclick: function () { answer = 'no'; lsSet(KEY.burner, { v: 'no' }); track('edc_quiz_burner', { has: 'no' }); paint(); } })
        ]));
        return;
      }
      if (answer === 'si') { box.appendChild(el('p', { class: 'edcq-aside__text', text: 'Perfecto, solo tienes que elegir tus aromas.' })); return; }
      var burners = (data.burners || []).map(function (b) { return { id: 'burner:' + b.handle, handle: b.handle, name: b.name }; })
        .filter(function (b) { return live[b.id] && live[b.id].available; });
      if (!burners.length) { box.appendChild(el('p', { class: 'edcq-aside__text', text: 'Ahora mismo no tenemos quemadores para cera disponibles en la web.' })); return; }
      box.appendChild(el('p', { class: 'edcq-aside__text', text: 'Estos quemadores sirven para wax melts según su ficha. Son un accesorio: el aroma lo ponen los wax melts.' }));
      box.appendChild(complementList('', burners.slice(0, 3), live, 'burner'));
    }
    paint();
    return box;
  }

  /* =========================================================
   * 6. ACCESOS: pestaña fija, enlaces y aparición automática
   * ========================================================= */
  function isOpenLink(a) {
    var href = a.getAttribute('href') || '';
    return /#encuentra-tu-aroma$/.test(href) || /[?&]guia-aromas(=|&|$)/.test(href);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || !isOpenLink(a)) return;
    var url; try { url = new URL(a.href, location.href); } catch (er) { return; }
    if (url.pathname !== location.pathname && !/#encuentra-tu-aroma$/.test(a.getAttribute('href'))) return;
    e.preventDefault();
    open('link');
  });

  function addTab() {
    if (NO_TAB_TEMPLATES.indexOf(cfg.template) !== -1) return;
    var tab = el('button', { type: 'button', class: 'edcq-tab', 'aria-haspopup': 'dialog', onclick: function () { open('tab'); } }, [
      el('span', { class: 'edcq-tab__dot', 'aria-hidden': 'true' }), el('span', { text: 'Encuentra tu aroma ideal' })
    ]);
    document.body.appendChild(tab);
  }

  function somethingElseOpen() {
    if (document.querySelector('dialog[open]:not(.edcq-dialog)')) return true;
    var banner = document.getElementById('shopify-pc__banner');
    if (banner && banner.offsetParent !== null && getComputedStyle(banner).display !== 'none') return true;
    var pref = document.getElementById('shopify-pc__prefs');
    if (pref && pref.offsetParent !== null) return true;
    return false;
  }

  function autoOpen() {
    if (cfg.designMode) return;
    if (AUTO_TEMPLATES.indexOf(cfg.template) === -1) return; // nunca en ficha, carrito ni checkout
    if (ssGet(KEY.session)) return;                 // como máximo una vez por sesión
    if (lsGet(KEY.dismissed, 7)) return;            // cerrado hace menos de 7 días
    if (lsGet(KEY.done, 30)) return;                // ya lo completó este mes
    var fired = false, timer;
    function fire(source) {
      if (fired || opened) return;
      if (somethingElseOpen() || document.visibilityState === 'hidden') { clearTimeout(timer); timer = setTimeout(function () { fire(source); }, 4000); return; }
      fired = true;
      global.removeEventListener('scroll', onScroll);
      open(source);
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h > 0.4) fire('auto-scroll');
    }
    timer = setTimeout(function () { fire('auto-time'); }, 15000);
    global.addEventListener('scroll', onScroll, { passive: true });
  }

  // Añadidos al carrito de productos recomendados (evento propio del tema Horizon)
  document.addEventListener('cart:update', function (e) {
    try {
      var d = (e.detail && e.detail.data) || {};
      if (d.didError) return;
      var recs = lsGet(KEY.recs, 7);
      if (!recs) return;
      var pid = d.productId ? String(d.productId) : '', vid = d.variantId ? String(d.variantId) : '';
      var hit = (vid && recs.variants.indexOf(vid) !== -1) || (pid && recs.products.indexOf(pid) !== -1);
      if (!hit || d.source === 'cart-items-component') return;
      track('edc_quiz_add_to_cart', { product_id: pid, variant_id: vid });
      if (!ssGet('edcq_attr')) {
        ssSet('edcq_attr', '1');
        fetch(cfg.base + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Guía de aromas': 'Sí' } })
        }).catch(function () {});
      }
    } catch (er) {}
  });

  function init() {
    addTab();
    var params = new URLSearchParams(location.search);
    if (location.hash === '#encuentra-tu-aroma' || params.has('guia-aromas')) { open('url'); return; }
    autoOpen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  global.EDCAromaQuiz = { open: open, Engine: Engine };
})(typeof window !== 'undefined' ? window : globalThis);
